export default {
  CONTACTS_LIST: "Liste des propriétaires",
  ADD_CONTACT: "Ajouter un propriétaire",
  CONTACTS: "Personnes ressources",
  CONTACT_ADDED: "Propriétaire ajouté",
  EDIT_CONTACT: "Modifier un propriétaire",
  CONTACT_UPDATED: "Propriétaire mise à jour",
  DELETE_THIS_CONTACT: "Supprimer ce propriétaire ?",
  CONTACT_DELETED: "Propriétaire supprimé",
  MISTER: "M.",
  MADAM: "Mme",
  CONTACT_TYPE: "Type de propriétaire",
  TITLE_MR: "M.",
  TITLE_MME: "Mme",
  VIEW_CONTACT: "Propriétaire",
  NO_ADDRESS_MESSAGE:
    "Ce propriétaire n'a pas d'adresse. Voulez-vous l'enregistrer avec l'adresse suivante par défaut?",
  ADDRESS_CONFIRMATION: "Confirmation d'adresse",
  PROPERTIES: "Propriétés",
  USE_DEFAULT_ADDRESS: "Utiliser l’adresse par défaut",
  WITHOUT_ADDRESS: "Ne pas mettre d’adresse",
  RETURN_TO_FROM: "Retourner au formulaire",
  SAME_CONTACTS:
    'Un ou plusieurs propriétaires ont déjà été enregistrés avec le prénom {firstname} et le nom {lastname}. S\'agit-il de la même personne ? Cliquez sur "Continuer" pour enregistrer si c\'est le cas, sinon cliquez sur "Annuler".',
  ACCOUNT_STATUS: 'Etat de compte',
  PRINT_ACCOUNT_STATUS: 'Imprimer',
  PRINT_ACCOUNT_STATUS_FILE_NAME_OF: "Etat_de_compte",
  SEND_ACCOUNT_STATUS_FILE_NAME_OF_QUESTION: "Etes-vous sùr de vouloir envoyer l'état de compte par mail",
  SEND_ACCOUNT_STATUS_FILE_NAME_OF: "Envoyer par mail",
  ACCOUNT_STATUS_FILE_SENDED: "Un mail est envoyé",
  ADDRESS_INCORRECT: "Adresses propriétaires incomplètes : ",
  ONE_ADDRESS_INCORRECT: "Une adresse propriétaire incomplète",
  ADDRESS_INCORRECT_CONFIRMATION: "Etes-vous certains de continuer l’importation ?",
  ADDRESS_EMPTY: "Adresses propriétaires manquantes : ",
  ONE_ADDRESS_EMPTY: "Une adresse propriétaire manquante",
  NO_MULTIPLE_ADDRESS_MESSAGE:
    " propriétaires n'ont pas d'adresse. Voulez-vous les enregistrer avec l'adresse suivante par défaut?",
  NO_ONE_ADDRESS_MESSAGE:
    "Un propriétaire n'a pas d'adresse. Voulez-vous l'enregistrer avec l'adresse suivante par défaut?",
  INCORRECT_ADDRESS_MESSAGE:
    " propriétaires ont des adresses incorrectes",
  ONE_INCORRECT_ADDRESS_MESSAGE:
    "Un propriétaire a une adresse incorrecte",
  ADDRESS_REQUIRED_MESSAGE: "Adresse obligatoire",
  CITY_REQUIRED_MESSAGE: "Ville obligatoire",
  ZIPCODE_REQUIRED_MESSAGE: "Adresse obligatoire",
  LEGAL_FORM_REQUIRED_MESSAGE: "Forme juridique obligatoire",
  CONSTITUTIVE_LAW_REQUIRED_MESSAGE: "Loi constitutive obligatoire"
};
